import { createAction } from '@reduxjs/toolkit';
import { type Operation } from 'fast-json-patch';
import { type ThemeType } from '~/_shared/themes/themeType';
import type { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import type { MapPageSplitScreenTab } from '~/map/page/splitScreen/mapPageSplitScreen.types';
import { type MapListSortType } from '../../../map/listing/mapListing.helpers';
import {
  USER_SETTINGS_MAP_DROPDOWN_UPDATE, USER_SETTINGS_SET_ALLOW_EDITING_BOUNDARY_GROUPS, USER_SETTINGS_SET_CONFIRMED_MIGRATION_WARNING, USER_SETTINGS_SET_SHOWN_WELCOME_MODAL, USER_SETTINGS_SET_TOOL_COLLAPSE,
  USER_SETTINGS_SPLIT_PANEL_CLOSE,
  USER_SETTINGS_SPLIT_PANEL_OPEN,
  USER_SETTINGS_SPLIT_PANEL_SET_TAB,
  USER_SETTINGS_SYNC_FAIL, USER_SETTINGS_SYNC_REQUEST, USER_SETTINGS_SYNC_SUCCESS,
  USER_SETTINGS_THEME_UPDATE,
} from './userDataSettings.actionTypes';

export const mapDropdownUpdate = (clientId: number, sortType: MapListSortType) => ({
  type: USER_SETTINGS_MAP_DROPDOWN_UPDATE,
  payload: {
    clientId,
    sortType,
  },
}) as const;

export const userSettingsThemeUpdate = (clientId: number, theme: ThemeType) => ({
  type: USER_SETTINGS_THEME_UPDATE,
  payload: {
    clientId,
    theme,
  },
}) as const;

export function userSettingsSyncRequest(diff: Operation[]) {
  return {
    type: USER_SETTINGS_SYNC_REQUEST,
    payload: {
      diff,
    },
  } as const;
}

export function userSettingsSyncRequestSuccess() {
  return {
    type: USER_SETTINGS_SYNC_SUCCESS,
  } as const;
}

export function userSettingsSyncRequestError() {
  return {
    type: USER_SETTINGS_SYNC_FAIL,
  } as const;
}

export const userSettingsSplitPanelOpen = (clientId: number, mapId: number) => ({
  type: USER_SETTINGS_SPLIT_PANEL_OPEN,
  payload: {
    clientId,
    mapId,
  },
}) as const;

export const userSettingsSplitPanelClose = (clientId: number, mapId: number) => ({
  type: USER_SETTINGS_SPLIT_PANEL_CLOSE,
  payload: {
    clientId,
    mapId,
  },
}) as const;

export const userSettingsSplitPanelSetTab = createAction(
  USER_SETTINGS_SPLIT_PANEL_SET_TAB,
  (clientId: number, mapId: number, newTab: MapPageSplitScreenTab) => ({
    payload: {
      clientId,
      mapId,
      newTab,
    },
  })
);

export const userSettingsSetToolCollapse = createAction(
  USER_SETTINGS_SET_TOOL_COLLAPSE,
  (clientId: number, mapId: number, mapTool: MapTool, newValue: boolean | undefined) => ({
    payload: {
      clientId,
      mapId,
      mapTool,
      newValue,
    },
  })
);

export const userSettingsSetAllowEditingBoundaryGroups = createAction(
  USER_SETTINGS_SET_ALLOW_EDITING_BOUNDARY_GROUPS,
  (clientId: number, allowEditing: boolean) => ({
    payload: {
      clientId,
      allowEditing,
    },
  })
);

export const userSettingsSetConfirmedMigrationWarning = createAction(
  USER_SETTINGS_SET_CONFIRMED_MIGRATION_WARNING,
  (clientId: number) => ({
    payload: { clientId },
  })
);

export const userSettingsSetShownWelcomeModal = createAction(
  USER_SETTINGS_SET_SHOWN_WELCOME_MODAL,
  (clientId: number) => ({
    payload: { clientId },
  })
);
